module.exports = __webpack_public_path__ + "global-903b6d5b.webp";